// ============================================================================
// The ONE write that changes a feedback report's status — shared by
// Admin → Feedback and the command center's Feedback tab (item #702), so the
// two screens cannot drift into two different saves (PLAYBOOK §15a).
//
// It sends what it is given and NOTHING ELSE. resolved_at and resolved_by are
// app_feedback_completion_guard's to stamp on the way into completed, wont_fix
// or duplicate, and it retracts all three on the way out. 'completed' needs a
// non-blank resolution (the guard and a CHECK refuse it otherwise); a reason
// given with wont_fix or duplicate is kept in the same resolution column.
//
// `.select('*').single()` is the proof the row was written: zero rows comes
// back as an error, never as a quiet success (PLAYBOOK §15 q.1).
// ============================================================================
import { supabase } from '../../shared/supabase';

export type FeedbackSave = {
  status: 'new' | 'triaged' | 'in_progress' | 'completed' | 'wont_fix' | 'duplicate';
  resolution?: string;
  duplicate_of?: string | null;
  admin_notes?: string | null;
};

export async function saveFeedback(id: string, payload: FeedbackSave) {
  return supabase.from('app_feedback').update(payload).eq('feedback_id', id).select('*').single();
}
